<template>
  <BaseProductMenuMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
